export default __webpack_public_path__ + "fonts/bookmark-white.svg";